import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Drawer, List, ListItemButton, ListItemText, Box, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Person,PersonAdd } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function LandingPageLayoutMobile({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const sections = [
    { id: 'hero', label: 'Home' },
    { id: 'problema', label: 'Il problema' },
    { id: 'soluzioni', label: 'Soluzioni' },
    { id: 'testimonianze', label: 'Testimonianze' },
    { id: 'prezzi', label: 'Prezzi' },
    { id: 'contatti', label: 'Contatti' },
    { id: 'accedi', label: 'Accedi' },
    { id: 'registrati', label: 'Registrati' },
  ];

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const scrollToSection = (id) => {
    setMobileOpen(false);
    if (id === 'accedi') navigate('/login');
    else if (id === 'registrati') navigate('/register');
    else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation">
      <List><PersonAdd />
        {sections.map((sec) => (
          <ListItemButton key={sec.id} onClick={() => scrollToSection(sec.id)}>
            {(sec.id === 'accedi') ? (
              <Tooltip title={sec.label}>
                <IconButton sx={{ color: '#2742F5' }}>
                  <Person />
                </IconButton>
              </Tooltip>
            ) : (sec.id === 'registrati') ? (
                              <Tooltip title={sec.label}>
                                <IconButton sx={{ color: '#2742F5' }}>
                                  <PersonAdd />
                                </IconButton>
                              </Tooltip>
                            ) : (
              <ListItemText primary={sec.label} />
            )}
          </ListItemButton>
        ))}
      </List>
    </Box>
  );

  return (
    <Box>
      <AppBar position="fixed" sx={{ bgcolor: '#F5F7FA', color: '#2742F5', boxShadow: 1 }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <IconButton edge="start" onClick={handleDrawerToggle} aria-label="Apri menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap sx={{ color: '#2742F5', fontWeight: 600 }}>
            DeskStudio
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: 250 } }}
      >
        {drawer}
      </Drawer>
      <Box sx={{ mt: 10 }}>{children}</Box>
    </Box>
  );
}